import React, { createContext, useContext, useState } from "react";

const HeaderActionsContext = createContext();

export const HeaderActionsProvider = ({ children }) => {
  const [selectedOption, setSelectedOption] = useState({
    label: "All Clinics",
    value: 0,
  });

  const [period, setPeriod] = useState({
    fromDate: new Date(),
    toDate: new Date(),
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState("from");

  const value = {
    selectedOption,
    setSelectedOption,
    period,
    setPeriod,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
  };

  return (
    <HeaderActionsContext.Provider value={value}>
      {children}
    </HeaderActionsContext.Provider>
  );
};

export const useHeaderActionsContext = () => {
  return useContext(HeaderActionsContext);
};
